import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { getSoftToken, logout, removeSoftToken, softLogin } from './AuthService';

export const BASE_API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://localhost/';
export const BASE_FE_URL = process.env.REACT_APP_FE_URL ? process.env.REACT_APP_FE_URL : 'http://localhost/';

axios.interceptors.request.use(async function (config: any) {
    const loginUrl = BASE_API_URL + "?op=login";
    let softToken = getSoftToken();

    if (!softToken &&
        config.method !== 'options' &&
        config.url !== loginUrl
    ) {
        softToken = await softLogin();
    }

    if (!softToken) {
        await logout();
        if (config.url !== loginUrl) {
            window.location.href = '/accedi'
        }
    } else {
        config.headers = { ...config.headers, 'Authorization': 'Bearer ' + softToken };
    }

    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function(response: AxiosResponse<any, any>) {
    return response
}, async function (error: any) {
    const statusCode = error.response ? error.response.status : null;

    if (statusCode === 401 || statusCode === 403) {
        if (window.location.pathname !== '/accedi'){
            await logout();
            await removeSoftToken();
            await softLogin();
        }
    }

    return Promise.reject(error);
})

export async function apiGet<T, E>(path: string, config?: AxiosRequestConfig) {
    return await axios.get(BASE_API_URL + path, config)
        .then(
            (response: AxiosResponse<{data: T}>) => {
            return response.data.data;
        })
        .catch(
            (reason: AxiosError<{data: E}>) => {
                return reason.response?.data.data;
            }
        );
}

export default axios;